import { createContext, useContext } from 'react'

/** When true, inline field errors from save validation (US-IB-03 §10.3 / BR-03) may render. */
export const BuilderSaveValidationContext = createContext(false)

export function useShowBuilderSaveValidation(): boolean {
  return useContext(BuilderSaveValidationContext)
}

/** Pure gate — safe after conditional returns when `show` is read once at component top. */
export function gateFieldError(
  show: boolean,
  message: string | null | undefined,
): string | null {
  return show && message ? message : null
}

/** Pure gate — safe after conditional returns when `show` is read once at component top. */
export function gateFieldErrorFlag(show: boolean, active: boolean): boolean {
  return show && active
}

export function useGatedBuilderFieldError(message: string | null | undefined): string | null {
  const show = useShowBuilderSaveValidation()
  return gateFieldError(show, message)
}

export function useGatedBuilderFieldErrorFlag(active: boolean): boolean {
  const show = useShowBuilderSaveValidation()
  return gateFieldErrorFlag(show, active)
}
